import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';

const pathname = window.location.pathname;
const container = document.getElementById('root');

const root = createRoot(container!);
root.render(
    <React.StrictMode>
        <App pathname={pathname} />
    </React.StrictMode>
);
